export default {
  root: {
    justifyContent: 'center',
    alignItems: 'center',
  },
};
